import React from 'react'
import Menu from './RodosMenu/Menu'


function Startermenu() {
    return (

        <>

            <Menu />

        </>

    )
}

export default Startermenu